"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getKeywordsText = void 0;
const common_enums_1 = require("@klear/common-enums");
function getKeywordsText(keywords, keywordsOperator = common_enums_1.InfluencerSearchKeywordOperator.OR, hideQuote = false) {
    return keywords.map(keyword => hideQuote ? keyword : `"${keyword}"`).join(` ${keywordsOperator} `);
}
exports.getKeywordsText = getKeywordsText;
//# sourceMappingURL=keywords.js.map